/* eslint-disable static-service/require-stories -- covered by dismissible.stories.tsx */
import {useCallback} from "react";

import {type Props} from "./props.ts";
import {useDismissible} from "./use-dismissible.ts";

export default function StandardDismissible({
    dismissKey,
    expiresDays,
    children,
    renderIfDismissed,
}: Omit<Props, "showOnce">): React.ReactElement {
    const {isDismissedResult, dismiss} = useDismissible(dismissKey);
    const shouldShow =
        isDismissedResult.status === "success" && !isDismissedResult.data;

    const handleDismiss = useCallback(
        () => dismiss(expiresDays),
        [dismiss, expiresDays],
    );

    return <>{shouldShow ? children(handleDismiss) : renderIfDismissed?.()}</>;
}
